import styled from 'styled-components';
import { Linha } from '../../styles/base';

export const GridContainerPrincipal = styled.div`
  background-color: #fff;
  padding: 9px 16px;
  border-radius: 4px;
  height: 100%;

  hr {
    border-top-color: #DEDEDD;
  }

  b {
    font-weight: 600;
  }
`;

export const PrintSic = styled.div`
  height: 100vh;
  width: 100%;
  background-color: blue;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
`;

export const LinhaItemSic = styled.div`
  display: grid;
  font-size: 15px;
`;

export const LinhaItemSicSecretaria = styled(Linha)`
  align-items: flex-start;
  grid-gap: 5px;

  @media screen and (max-width: 800px) {
    flex-direction: column;
  }
`;

export const LinhaItemSicSpaceBetween = styled.div`
  display: flex;
  align-items: center;
  grid-gap: 5px;
  justify-content:space-between;
  
  @media screen and (max-width: 800px) {
    flex-direction: column;
  }
`;

export const LinhaItemSicImpressao = styled(Linha)`
  justify-content: flex-end;

  @media screen and (max-width: 800px) {
    order: -1;
    align-self: flex-end;
  }
`;

export const GridArquivos = styled.div`
  display: grid;
  grid-gap: ${(props) => (props.totem ? '32px' : '24px')};
  max-height: 270px;
  overflow-y: auto;
  padding-inline: 7px;

  ::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 7px;
  }

  ::-webkit-scrollbar-corner {
    background-color: #fbfaf5;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #dfe4ea;
  }

  @media screen and (min-width: 500px) {
    grid-template-columns: repeat(auto-fill, minmax(10em, 1fr));
  }
`;

export const BoldTitulo = styled.b`
  font-size: 15px;
`;

export const ContainerJustifyEnd = styled.div`
  justify-self: flex-end;
`;
